import { createSlice } from '@reduxjs/toolkit';
import {
  getCampaignOverview,
  getDashboardMetrics,
  getUserMetrics,
  getUserMetricsHourly,
} from '../actions/metrics';

const initialState = {
  campaignsMetrics: [],
  userMetrics: {
    metrics: {},
    isLoading: false,
  },
  userMetricsHourly: {
    hourlyMetrics: [],
    isLoading: false,
  },
};

const getOverviewOrDashboardPending = (state) => {
  state.isMetricsLoading = true;
  state.campaignsMetrics = [];
  state.error = false;
};

const getOverviewOrDashboardFulfilled = (state, action) => {
  const [campaignsMetrics] = [...action.payload.metrics];
  state.campaignsMetrics = campaignsMetrics || [];
  state.isMetricsLoading = false;
};

const getOverviewOrDashboardRejected = (state, action) => {
  state.isMetricsLoading = false;
  state.error = action.payload.error;
};

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getCampaignOverview.pending, (state) => getOverviewOrDashboardPending(state));

    builder.addCase(getCampaignOverview.fulfilled, (state, action) =>
      getOverviewOrDashboardFulfilled(state, action),
    );

    builder.addCase(getCampaignOverview.rejected, (state, action) =>
      getOverviewOrDashboardRejected(state, action),
    );

    builder.addCase(getDashboardMetrics.pending, (state) => getOverviewOrDashboardPending(state));

    builder.addCase(getDashboardMetrics.fulfilled, (state, action) =>
      getOverviewOrDashboardFulfilled(state, action),
    );

    builder.addCase(getDashboardMetrics.rejected, (state, action) =>
      getOverviewOrDashboardRejected(state, action),
    );

    builder.addCase(getUserMetrics.pending, (state) => {
      state.userMetrics.isLoading = true;
      state.userMetricsError = false;
    });

    builder.addCase(getUserMetrics.fulfilled, (state, action) => {
      const [userMetrics] = [...action.payload.metrics];
      state.userMetrics.metrics = userMetrics;
      state.userMetrics.isLoading = false;
    });

    builder.addCase(getUserMetrics.rejected, (state, action) => {
      state.userMetrics.isLoading = false;
      state.userMetricsError = action.payload.error;
    });

    builder.addCase(getUserMetricsHourly.pending, (state) => {
      state.userMetricsHourly.isLoading = true;
      state.userMetricsHourlyError = false;
    });

    builder.addCase(getUserMetricsHourly.fulfilled, (state, action) => {
      state.userMetricsHourly.hourlyMetrics = action.payload.hourlyMetrics;
      state.userMetricsHourly.isLoading = false;
    });

    builder.addCase(getUserMetricsHourly.rejected, (state, action) => {
      state.userMetricsHourly.isLoading = false;
      state.userMetricsHourlyError = action.payload.error;
    });
  },
});

export default metricsSlice;
